/**
 * Temporary storefront fix: anonymous IndexController page_cache still serves
 * a deleted Horizon homepage (lake SVG). Replace it with brand commute photo.
 * Remove this ScriptTag once Shopify purges page_cache for /.
 */
(function () {
  try {
    if (window.__ZIILAY_HERO_FIX__) return;
    window.__ZIILAY_HERO_FIX__ = true;

    var DENIM =
      'https://cdn.shopify.com/s/files/1/0723/0036/3907/t/6/assets/ziilay-indigo-denim-commute-hero.jpg';
    var CHINO =
      'https://cdn.shopify.com/s/files/1/0723/0036/3907/t/6/assets/ziilay-commute-hero.jpg';

    function isLakeHero() {
      return !!document.querySelector(
        'section.hero-wrapper svg.hero__media, .hero__media-grid svg.hero__media, svg.hero__media'
      );
    }

    function replaceLake() {
      var svg = document.querySelector(
        'section.hero-wrapper svg.hero__media, .hero__media-grid svg.hero__media, svg.hero__media'
      );
      if (!svg) return false;

      var img = document.createElement('img');
      img.src = DENIM;
      img.alt = 'Ziilay trousers for working men — commute in indigo denim';
      img.width = 1536;
      img.height = 1024;
      img.fetchPriority = 'high';
      img.className = 'hero__media';
      img.style.cssText =
        'width:100%;height:100%;object-fit:cover;object-position:center;display:block;';

      if (svg.parentNode) {
        svg.parentNode.replaceChild(img, svg);
        return true;
      }
      return false;
    }

    function run() {
      if (!isLakeHero()) return;
      replaceLake();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
  } catch (e) {}
})();
